






















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
	VatsApi,
	Vat,
	GraphsApi,
	NotificationsApi,
	EventSubscriptionsApi,
	EventTypesApi,
} from '../../api';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import {
	EventType,
	filterEntityEventTypes,
	filterEntityEventSubscriptions,
} from '@/models/event-subscription';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: {},
	props: {
		productId: Number,
		entityType: String | null,
		productType: String | null,
		entityId: Number | null,
	},
})
export default class DeletedEventSubscriptionAudits extends Vue {
	public productId: number | undefined;
	public entityId: number | undefined;
	public entityType: number | undefined;

	public dateForm = {
		start: moment()
			.subtract(30, 'days')
			.locale('en-nz')
			.format('X')
			.toString(),
		end: moment()
			.locale('en-nz')
			.format('X')
			.toString(),
	};

	private audits: any[] = [];
	private eventTypes: EventType[] = [];

	public auditFields = [
		{ key: 'createdAt', label: 'Deleted' },
		{ key: 'eventTypeName', label: 'Event Type' },
		{ key: 'subscriberName', label: 'Subscriber Name' },
		{ key: 'oldValues', label: 'Values' },
		{ key: 'userName', label: 'Deleted By' },
	];

	public created() {
		this.dateChange();
	}

	@Watch('dateForm')
	public dateChange() {
		if (this.dateForm.end === null || this.dateForm.start === null) {
			return;
		}
		this.notificationData();
	}

	public async notificationData() {
		try {
			const types: any = await new EventTypesApi().getEventTypesByProductType(this.productType);
			this.eventTypes = filterEntityEventTypes(types.data.data, this.entityType) as EventType[];

			const { data } = await new EventSubscriptionsApi().getDeletedEventSubscriptionAudits(
				parseInt(this.productId, 10),
				parseInt(this.dateForm.start, 10),
				parseInt(this.dateForm.end, 10),
			);

			this.audits = data.data.map(audit => {
				let oldValues = JSON.parse(audit.oldValues);
				let eventType = this.eventTypes.find(et => et.id == oldValues.eventTypeId);
				return {
					...audit,
					oldValues: oldValues,
					eventType: eventType ? eventType.title : 'Not Found',
				};
			});

			if (this.entityType == 'tanks') {
				return this.audits.filter(audit => audit.entityId == this.entityId);
			} else if (this.entityType === 'vats') {
				return this.audits;
			} else {
				return this.audits.filter(
					audit => audit.entityId == this.entityId && audit.entityType!.includes(this.entityType),
				);
			}
		} catch (e) {
			console.log(e);
		}
	}
}
